export class DiffuseurItem {
	public id: string;
	public zonediffusion: string;
	public diffuseur: string;
	public format: string;
	public idParent: string;
	public support: string;
	public children: DiffuseurItem[];
	public actions: any[];
	public develop: boolean;
	public checked: boolean;
	public visible: boolean;

	constructor() {
		this.children = [];
		this.actions = [];
		this.checked = false;
		this.visible = false;
		this.develop = false;
	}
}
